import store from '../../../index';

export default {
    namespaced: true,
    state: {
        currentRa3d: {},
        defaultRa3d: {
            file: {
                path: '',
                name: ''
            },
            coordinate: ['0', '0', '0'],
            scale: '10000',
            mode: '0',
            rotation: ['0', '0', '0']
        }
    },

    getters: {
        defaultRa3d: (state) => {
            return state.defaultRa3d;
        }
    },

    mutations: {
        SET_DATA: (state, data) => {
            state.currentRa3d = Object.assign({}, state.currentRa3d, data);
        },
        SET_DATA_COORDINATE: (state, data) => {
            state.currentRa3d.coordinate[data.index] = data.value;
        },
        SET_DATA_ROTATION: (state, data) => {
            state.currentRa3d.rotation[data.index] = data.value;
        },
        CLEAN_CURRENT_DATA: (state) => {
            state.currentRa3d = {};
        }
    },

    actions: {
        ra3dUpdate: function (localStore) {
            return new Promise(function (resolve, reject) {
                let value = { ...localStore.state.currentRa3d };
                store.dispatch('actions/updateActionData', value).then(() => {
                    resolve();
                }).catch((err) => {
                    reject(err);
                });
            });
        }
    }
};
